import { render, staticRenderFns } from "./AddModelDialog.vue?vue&type=template&id=052ff770&scoped=true"
import script from "./AddModelDialog.vue?vue&type=script&lang=js"
export * from "./AddModelDialog.vue?vue&type=script&lang=js"
import style0 from "./AddModelDialog.vue?vue&type=style&index=0&id=052ff770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052ff770",
  null
  
)

export default component.exports